const MAP = {
  // leads / generic statuses
  New: "cyan", "Attempted Contact": "slate", Contacted: "sky", Interested: "green",
  "Meeting Scheduled": "violet", "Proposal Sent": "amber", "Follow-Up": "orange",
  Negotiating: "pink", Won: "green", Lost: "red", "Do Not Contact": "slate",
  // priority
  Hot: "pink", Warm: "amber", Cold: "slate", High: "red", Medium: "amber", Low: "slate",
  // lifecycle
  Prospect: "slate", Lead: "cyan", Opportunity: "violet", Advertiser: "green",
  "Former Customer": "slate", Archived: "slate",
  // commission / payment / agreement
  Pending: "amber", Approved: "sky", Paid: "green", Cancelled: "slate",
  Unpaid: "red", "Partially Paid": "amber", "Deposit Received": "sky", Overdue: "red",
  Draft: "slate", Signed: "green", Open: "cyan", Completed: "green",
};

const STYLES = {
  cyan: "bg-[#00C9E0]/15 text-[#008395] border-[#00C9E0]/30",
  green: "bg-[#9ACC32]/15 text-[#5B880C] border-[#9ACC32]/30",
  pink: "bg-[#FE3967]/15 text-[#D01A46] border-[#FE3967]/30",
  orange: "bg-[#FE421C]/15 text-[#C42607] border-[#FE421C]/30",
  red: "bg-[#FE421C]/15 text-[#C42607] border-[#FE421C]/30",
  amber: "bg-amber-100 text-amber-700 border-amber-200",
  violet: "bg-violet-100 text-violet-700 border-violet-200",
  sky: "bg-sky-100 text-sky-700 border-sky-200",
  slate: "bg-slate-100 text-slate-600 border-slate-200",
};

export function StatusChip({ value, tone }) {
  if (!value) return <span className="text-slate-400">—</span>;
  const key = tone || MAP[value] || "slate";
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${STYLES[key]}`}>
      {value}
    </span>
  );
}
